import React from 'react';
import { Badge,Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { downloadImage } from '../../../utils/downloadImage';
import { isEmpty } from 'lodash';
import FormImage from '../../common/FormImage';

const Header = ({handleShowCmpare}) => {
    const textures = useSelector(state => state.texture);
    const picState = useSelector(state => state.picture);

    return ( 
        <div className='w-100 d-flex web-header'>
            <div className='header-wrapper text-right ps-4'>
                <label htmlFor='file-input'>
                    <a className='btn bg-light py-2 px-2 m-1 text-dark shadow-sm'><i className='fa fa-camera me-2 pt-1'></i>عکاسی دوباره</a>
                </label>
                <Button variant='light' className='p-2 m-1 text-dark shadow-sm d-none'>فروشگاه‌های حضوری</Button>
            </div>
            <div className='header-wrapper header-wrapper-logo text-center'>
                <img src={isEmpty(textures) ? "" : textures[0][0].ticon} alt="logo-company"/>
            </div>
            <div className='header-wrapper text-end pe-4'>
                <Badge pill bg='none' className='p-2 m-1' onClick={handleShowCmpare}>
                    <img src="../assets/images/compare_icon.png" alt='Compare-icon' width='38' height='38'/>
                </Badge>
                <Badge pill bg='none' className='p-2 m-1'  onClick={e => downloadImage(picState.img,picState.name)}>
                    <img src='../assets/images/download-icon.png' alt='download-icon'/>
                </Badge>
                <Badge pill style={{backgroundColor:'var(--themeColor)'}} bg='none' className='p-2 m-1 text-white d-none'>
                    <img src='../assets/images/cart-icon.png' alt='cart'/>
                </Badge>
            </div>
            <FormImage/>
        </div>
    );
}
 
export default Header;